import { Route } from 'react-router-dom';
import { reconductionsPourAssistantPotentielSchema } from './reconductionsPourAssistantPotentiel';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module ReconductionsPourAssistantPotentiel
 */
const ReconductionsPourAssistantPotentielRoutes = [
    // Route de liste (principale)
    <Route
        key="reconductions-pour-assistant-potentiel"
        path="reconductionsPourAssistantPotentiel"
        element={
            <Main
                key="reconductions-pour-assistant-potentiel-main"
                pageConfig={reconductionsPourAssistantPotentielSchema}
            />
        }
    />,
];

export default ReconductionsPourAssistantPotentielRoutes;
